import { IPropertyGroup } from "@app/propertyGroup/types";

import { PropertyProviderModes } from "../constants/PropertyProviderModes";
import { detectProperty } from "./appUtils";

export const resolveNextActiveProperty = ({
    mode,
    propertyGroup,
    recoveredActivePropertyId,
    configuredPropertyId,
}: {
    mode: PropertyProviderModes;
    propertyGroup?: IPropertyGroup;
    configuredPropertyId?: string;
    recoveredActivePropertyId?: string;
}): { nextActivePropertyId?: string; isRecoveredValueOverwritten?: boolean; nextChildPage?: string } => {
    if (mode === PropertyProviderModes.SingleProperty) {
        return { nextActivePropertyId: configuredPropertyId };
    } else {
        const detectedProperty = detectProperty(propertyGroup!);

        /**
         * @note: detected property is leading following previous implementation. Is this correct?
         */
        if (recoveredActivePropertyId) {
            if (recoveredActivePropertyId === detectedProperty) {
                return {
                    nextActivePropertyId: recoveredActivePropertyId,
                };
            }

            return {
                nextActivePropertyId: detectedProperty || recoveredActivePropertyId,
                isRecoveredValueOverwritten: true,
                nextChildPage: detectedProperty || recoveredActivePropertyId ? "search" : "property-select",
            };
        }

        return {
            nextActivePropertyId: detectedProperty,
            isRecoveredValueOverwritten: !detectedProperty,
            nextChildPage: !!detectedProperty ? "search" : "property-select",
        };
    }
};
